<template>
  <div class="app-container">
    <el-form class="header-filter">
      <div class="filter-container">
        <div class="filter-form">
          <el-form-item>
            <el-input
              v-model="query.name"
              @keyup.enter.native="resetList"
              placeholder="名称"
            ></el-input>
          </el-form-item>
        </div>
        <div class="filter-btns">
          <el-button @click="resetList" type="primary">确认查询</el-button>
        </div>
      </div>
    </el-form>

    <div class="table-wrapper">
      <el-table :data="list" v-loading="listLoading">
        <el-table-column
          align="center"
          type="index"
          width="60"
          fixed="left"
          label="#"
        ></el-table-column>
        <el-table-column align="center" label="名称">
          <template slot-scope="scope">
            {{ scope.row.name | filterName }}
          </template>
        </el-table-column>
        <el-table-column align="left" label="内容">
          <template slot-scope="scope">
            <i v-if="scope.row.type === 'editor'" style="color: #aaa"> 富文本内容 </i>
            <div v-else-if="scope.row.type === 'input'" style="color: #aaa">合伙人等级</div>
            <div v-else-if="scope.row.type === 'upload'" style="color: #aaa">图片</div>
            <div v-else-if="scope.row.type === 'textarea'" style="color: #aaa">长内容</div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="表格操作" width="150" fixed="right">
          <template slot-scope="scope">
            <p>
              <el-button type="primary" @click="handleEdit(scope.row)">编辑</el-button>
            </p>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="编辑参数" :visible.sync="dialogVisible" :width="form.dialogWidth || '450px'">
      <el-form class="post-main-container post-dialog-container">
        <el-form-item label="名称：" class="form-text">
          {{ form.name | filterName }}
        </el-form-item>
        <div v-if="form.type === 'editor'" class="dialog-editor-container">
          <el-form-item label="内容：">
            <Tinymce @listenChangeEditorValue="changeEditorValue" :value="form.value"></Tinymce>
          </el-form-item>
        </div>
        <div v-if="form.type === 'input'">
          <el-form-item label="内容：">
            <div v-for="(item, index) in form.value" :key="index" class="flex items-center">
              <el-input v-model="item.name" class="mb-8px w-200px" />
              <div @click="handleClick(index)">
                <i class="el-icon-circle-plus" v-if="index === 0"></i>
                <i class="el-icon-remove" v-else></i>
              </div>
            </div>
          </el-form-item>
        </div>
        <div v-if="form.type === 'textarea'">
          <el-form-item label="内容：">
            <el-input
              v-model="form.value"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 10 }"
            />
          </el-form-item>
        </div>
        <template v-if="form.type === 'upload'">
          <el-form-item label="图片:" class="h-150px">
            <div class="h-150px flex justify-start">
              <com-upload
                class=""
                style="left: 0"
                :originData="form.value"
                @postImage="handleUpload"
                @deleteImageUrl="deleteImageUrl"
              ></com-upload>
            </div>
          </el-form-item>
        </template>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitData" :loading="btnLoading">提交</el-button>
        <el-button @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Tinymce from '@/components/tinymce'
import { getSetting, submitSetting } from '@/api/setting'

export default {
  components: { Tinymce },

  data() {
    return {
      list: [],
      listTotal: 0,
      listLoading: true,

      query: {
        pageIndex: 1,
        pageSize: 100
      },

      btnLoading: false,
      dialogVisible: false,
      form: {
        id: '',
        name: '',
        type: '',
        value: '',
        dialogWidth: '',
        code: '',
        key: ''
      }
    }
  },

  filters: {
    filterName(val) {
      const map = {
        ABOUT_US: '关于我们',
        PRIVACY_POLICY: '隐私权政策',
        USER_AGREEMENT: '用户协议',
        PARTNER_LEVEL: '合伙人等级',
        VERSION: '版本号',
        // MONTH_CARD: '月卡温馨提示',
        // MONTH_CARD_PICTURE: '月卡开通提示卡',
        WALLET_EXPLAIN: '钱包提示',
        CHARGE_RULE_EXPLANATION: '充电规则说明',
        PACKAGE_PURCHASE_NOTICE: '套餐卡购买须知',
        CHARGING_PROTOCOL: '充电协议',
        RECHARGING_PROTOCOL: '充值协议',
        PACKAGE_BUY_PROTOCOL: '套餐购买协议'
      }

      return map[val] || val
    }
  },

  created() {
    this.resetList()
  },

  methods: {
    resetList() {
      this.query.pageIndex = 1
      this.getList()
    },

    getList() {
      this.listLoading = true

      getSetting(this.query).then((res) => {
        res.data.records = res.data.records.filter(
          (item) =>
            [
              'ABOUT_US',
              'PRIVACY_POLICY',
              'USER_AGREEMENT',
              'PARTNER_LEVEL',
              'VERSION',
              // 'MONTH_CARD',
              'WALLET_EXPLAIN',
              // 'MONTH_CARD_PICTURE',
              'CHARGE_RULE_EXPLANATION',
              'PACKAGE_PURCHASE_NOTICE',
              'CHARGING_PROTOCOL',
              'RECHARGING_PROTOCOL',
              'PACKAGE_BUY_PROTOCOL'
            ].indexOf(item.key) !== -1
        )

        this.list = res.data.records.map((item) => {
          if (
            [
              'ABOUT_US',
              'PRIVACY_POLICY',
              'USER_AGREEMENT',
              'VERSION',
              'WALLET_EXPLAIN',
              'CHARGE_RULE_EXPLANATION',
              'PACKAGE_PURCHASE_NOTICE',
              'CHARGING_PROTOCOL',
              'RECHARGING_PROTOCOL',
              'PACKAGE_BUY_PROTOCOL'
            ].indexOf(
              item.key
            ) !== -1
          ) {
            item.type = 'editor'
            item.dialogWidth = '700px'
          } else if (item.key === 'PARTNER_LEVEL') {
            item.type = 'input'
            item.dialogWidth = '400px'
            item.value = JSON.parse(item.value)
          } else if (item.key === 'MONTH_CARD_PICTURE') {
            item.type = 'upload'
            item.dialogWidth = '500px'
          } else if (item.key === 'MONTH_CARD') {
            item.type = 'textarea'
            item.dialogWidth = '500px'
          }
          return item
        })

        this.listTotal = parseInt(res.data.pager.itemCount)
        this.listLoading = false
      })
    },

    handleCurrentChange(val) {
      this.query.current = val
      this.getList()
    },

    handleEdit(row) {
      this.dialogVisible = true

      this.$resetForm(this.form, row)
    },

    changeEditorValue(val) {
      this.form.value = val
    },

    generateUUID() {
      // eslint-disable-next-line no-var
      var d = new Date().getTime()
      if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now() // use high-precision timer if available
      }
      // eslint-disable-next-line no-var, vars-on-top
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line no-var, no-bitwise
        var r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        // eslint-disable-next-line eqeqeq, no-bitwise
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16)
      })
      return uuid
    },

    handleClick(index) {
      if (index !== 0) {
        this.form.value.splice(index, 1)
        return
      }
      const params = {
        code: this.generateUUID(),
        name: ''
      }
      this.form.value.push(params)
    },
    handleUpload(opt) {
      this.form.value = opt
    },
    deleteImageUrl() {
      this.form.value = ''
    },

    submitData() {
      this.btnLoading = true
      const form = JSON.parse(JSON.stringify(this.form))
      if (form.type === 'input') form.value = JSON.stringify(form.value)

      submitSetting(form).then(() => {
        this.btnLoading = false
        this.dialogVisible = false

        this.$message.success('提交数据成功')
        this.getList()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-editor-container {
  height: 400px;
}
</style>
